export enum ArrowDirection {
  LEFT = "left",
  RIGHT = "right",
}

export const arrowDirection = (to: ArrowDirection) => {
  if (to === ArrowDirection.LEFT) {
    return {
      zIndex: 2,
      marginLeft: "7px",
      width: "26px",
      height: "26px",
    };
  }
  if (to === ArrowDirection.RIGHT) {
    return {
      zIndex: 2,
      marginRight: "-7px",
      transform: "rotate(180deg) translateY(50%)",
      width: "26px",
      height: "26px",
    };
  }

  return {};
};
